/**
 * 商户操作记录相关API
 */
import request from '@/utils/request'

/**
 * 添加商户操作记录
 * @param {Object} data - 操作记录数据
 * @param {string} data.orderId - 月卡订单ID
 * @param {string} data.businessId - 商户ID
 * @param {string} data.operatorId - 操作人ID
 * @param {string} data.operationContent - 操作内容
 * @param {string} data.operationTime - 操作时间（可选）
 * @returns {Promise}
 */
export function addBusinessOperationRecord (data) {
  return request({
    url: '/market/business/operation-record/add',
    method: 'post',
    data
  })
}

export default {
  addBusinessOperationRecord
}

